module.exports = __webpack_public_path__ + "img/house_pv_panel_on.167ff1c4.png";